import { SalaryFilterKeyString } from 'InstitutionalManagement/types'

export const SALARY_FIELDS_INITIAL_VALUES: SalaryFilterKeyString = {
  id: '',
  name: '',
  description: '',
  status: '',
}
